var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",class:{'is-selected': _vm.isSelected, 'is-clickable': _vm.isClickable},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }